export const nearbyUnits = {
  'Nearby clinics': 'Clínicas próximas',
  'Nearest clinic': 'Clínica mais próxima',
  'Other nearby clinics': 'Outras clínicas próximas',
  'See all clinics': 'Ver todas as clínicas',
  'The clinic at {{name}} is near you':
    'A clínica em {{name}} está pertinho de você',
  'These are other units that are near you':
    'Estas são outras unidades que estão perto de você',
  'We could not find any units near your location':
    'Não conseguimos encontrar nenhuma unidade próxima da sua localização',
};
